import React from 'react';
import {Link} from 'react-router-dom';
import './audioguide-promo.css';

const AudioguidePromo = () => {
  const data = require('../../other.json');
  return (
    <div
      className="audioguide-promo"
      style={{backgroundImage: 'url(./images/films.jpg)'}}
    >
      <div className="audioguide-promo__container">
        <div className="audioguide-promo__inner">
          <h2 className="audioguide-promo__title">Озвученные диафильмы</h2>
          <div className="audioguide-promo__text" dangerouslySetInnerHTML={{ __html: data.audioguidePromo.audioguidePromo }} />
          <div className="audioguide-promo__buttons">
            <Link
              to="/page/0"
              className="link audioguide-promo__button-1"
            >
              <img
                className="audioguide-promo__icon"
                src="./images/sound-button.svg"
                alt="Аудиогид"
              />
              <div className="audioguide-promo__button-text">
                Диафильмы со звездами
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

// <a
//   className="link"
//   href="https://ok.ru/visitfinland/app/512000898984"
//   rel="noopener noreferrer"
//   target="_blank"
// >
//   <div
//     className="audioguide-promo__button-2"
//   >
//     <div className="audioguide-promo__button-text">
//       Пройти тест
//     </div>
//   </div>
// </a>

export default AudioguidePromo;
